import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  flag: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Carolina Bianchi',
  role: 'Istruttrice di Pilates Reformer',
  location: 'Milano, Italia',
  flag: '🇮🇹',
  quote: 'Ho comprato il Megapack una domenica sera. Il lunedì sono entrata in studio con la lezione esatta pianificata. Le lezioni del Volume 1 sono proprio quello di cui avevo bisogno per i miei gruppi di principianti. Non improvviso mai più.',
  initials: 'CB',
  color: '#8B6FBF'
}, {
  name: 'Lucia Ferrari',
  role: 'Studio Owner — Mat & Reformer',
  location: 'Roma, Italia',
  flag: '🇮🇹',
  quote: "Il miglior investimento dell'anno. Le schede cliniche mi hanno dato la sicurezza per lavorare con allieve con ernie e scoliosi. Non improvviso più, arrivo con un piano chiaro e professionale.",
  initials: 'LF',
  color: '#D4A574'
}, {
  name: 'Andrea Salatti',
  role: 'Istruttrice certificata',
  location: 'Torino, Italia',
  flag: '🇮🇹',
  quote: 'Pensavo fosse "il solito PDF", ma questo è un altro livello. I 6 volumi sono organizzati per obiettivo e livello — trovo quello che mi serve all\'istante. Per €19 è un regalo.',
  initials: 'AS',
  color: '#0F8B6F'
}, {
  name: 'Valentina Rossi',
  role: 'Istruttrice di Pilates Clinico',
  location: 'Napoli, Italia',
  flag: '🇮🇹',
  quote: 'La Guida Variazioni in 3 Livelli ha eliminato il problema del gruppo eterogeneo. Ora mostro le 3 versioni di ogni esercizio e ogni allieva sceglie quella adatta. Vale 10 volte quello che costa.',
  initials: 'VR',
  color: '#D98AA8'
}, {
  name: 'Maria Greco',
  role: 'Istruttrice & Fisioterapista',
  location: 'Bologna, Italia',
  flag: '🇮🇹',
  quote: 'I blocchi per popolazioni speciali sono oro puro. Lavoro con donne in gravidanza e anziani e finalmente ho materiale professionale affidabile. Lo Script della Prima Lezione mi ha cambiato la conversione.',
  initials: 'MG',
  color: '#8B6FBF'
}, {
  name: 'Sofia Marini',
  role: 'Istruttrice Reformer Avanzato',
  location: 'Firenze, Italia',
  flag: '🇮🇹',
  quote: "L'ho scaricato un venerdì e il lunedì stavo già dando lezioni nuove. Compatibile con tablet, quindi lo porto in studio senza stampare nulla. Il tasso di abbandono dei miei gruppi è crollato.",
  initials: 'SM',
  color: '#D4A574'
}, {
  name: 'Daniela Conti',
  role: 'Istruttrice Mat & Props',
  location: 'Verona, Italia',
  flag: '🇮🇹',
  quote: "Il Calendario Annuale e le Playlist curate mi fanno risparmiare ore ogni settimana. Le mie lezioni hanno un ritmo professionale e le mie allieve lo notano. L'investimento si è ripagato nella prima settimana.",
  initials: 'DC',
  color: '#0F8B6F'
}, {
  name: 'Patrizia Vitale',
  role: 'Istruttrice certificata',
  location: 'Genova, Italia',
  flag: '🇮🇹',
  quote: 'Dopo 8 anni di lezioni sentivo di ripetere sempre lo stesso. Il Volume III (Flow Dinamico) mi ha dato freschezza. Le allieve avanzate ora si sentono di nuovo sfidate.',
  initials: 'PV',
  color: '#D98AA8'
}, {
  name: 'Isabella Romano',
  role: 'Istruttrice Pilates Reformer',
  location: 'Palermo, Italia',
  flag: '🇮🇹',
  quote: 'I protocolli per allieve con ernie e osteoporosi sono precisi: cosa fare, cosa non fare, cosa dire. Ora lavoro con tranquillità e le mie allieve si fidano di più di me.',
  initials: 'IR',
  color: '#8B6FBF'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-297">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-298"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-299">
        <div className="text-center mb-10 sm:mb-14" data-id="element-300">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-301">
            ⭐ Testimonianze reali
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-302">
            Istruttrici in tutta <span className="text-primary" data-id="element-303">Italia</span> lo
            usano già.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4 flex-wrap" data-id="element-304">
            <span className="text-[#E0A52E] text-base sm:text-lg" data-id="element-305">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-306">
              4.9/5 · +800 recensioni verificate
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-307">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(90,70,120,0.15)] flex flex-col relative" data-id="element-308">
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/15 leading-none select-none" data-id="element-309">
                "
              </span>

              <div className="flex items-center gap-2 mb-3" data-id="element-310">
                <span className="text-[#E0A52E] text-sm" data-id="element-311">⭐⭐⭐⭐⭐</span>
                <span className="text-xl" aria-hidden="true" data-id="element-312">
                  {t.flag}
                </span>
              </div>

              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-313">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-314">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-315">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-316">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-317">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-318">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-319">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-320">
          Oltre{' '}
          <span className="text-primary font-bold" data-id="element-321">15.000 istruttrici</span> in
          tutta Italia insegnano già con PILATES PRONTA.
        </p>
      </div>
    </section>;
}